import React from 'react';
import ServiceCard from '../components/ServiceCard';
import PageHeader from '../components/PageHeader';

const Home = () => {
  const homeServices = [
    {
      icon: '/images/SIDT.png',
      title: 'CONSULTING SERVICES',
      description: 'Expert guidance for your business transformation needs.',
      linkTo: '/services',
      details: [
        {
          title: 'Strategic Consulting',
          items: [
            'Business process optimization',
            'Digital transformation strategy',
            'Technology roadmap planning',
            'Change management consulting'
          ]
        }
      ]
    },
    {
      icon: '/images/AI.png',
      title: 'DEVELOPMENT',
      description: 'Custom software solutions tailored to your requirements.',
      linkTo: '/services',
      details: [
        {
          title: 'Custom Development',
          items: [
            'Web application development',
            'Mobile app development',
            'API development and integration',
            'Legacy system modernization'
          ]
        }
      ]
    },
    {
      icon: '/images/Data.png',
      title: 'AUTOMATION & OPTIMIZATION',
      description: 'Streamline your processes with intelligent automation.',
      linkTo: '/services',
      details: [
        {
          title: 'Process Automation',
          items: [
            'Robotic Process Automation (RPA)',
            'Workflow automation',
            'AI-powered automation',
            'Business process optimization'
          ]
        }
      ]
    },
    {
      icon: '/images/Cloud.png',
      title: 'IT & DATA SOLUTIONS',
      description: 'Comprehensive data management and IT infrastructure.',
      linkTo: '/services',
      details: [
        {
          title: 'Data & Infrastructure',
          items: [
            'Data architecture and management',
            'Cloud infrastructure setup',
            'IT security and compliance',
            'Business intelligence solutions'
          ]
        }
      ]
    }
  ];

  return (
    <div>
      <PageHeader 
        title="INSPIRE. ENABLE. THRIVE"
        subtitle="Simplifying Complexity, Empowering Innovation"
        backgroundImage="/images/homebg.png"
      />

      <section className="services-section" style={{ backgroundColor: '#4298DC' }}>
        <div className="container">
          <h2 className="section-title">Services Include:</h2>
          <div className="services-grid">
            {homeServices.map((service, index) => (
              <ServiceCard
                key={index}
                icon={service.icon}
                title={service.title}
                description={service.description}
                details={service.details}
                linkTo={service.linkTo}
              />
            ))}
          </div>
        </div>
      </section>

      <section className="why-section" style={{ background: 'url(/images/WorkWith.png) center/cover no-repeat' }}>
        <div className="container">
          <div className="why-content">
            <div className="why-text">
              <h2>WHY WORK WITH US</h2>
              <p>Trusted. Experienced. Results-Driven.</p>
              <p>At MindXchange, we believe that success is built on trust, expertise, and measurable results. Our team brings decades of combined experience delivering world-class solutions for diverse industries with standards of delivering exceptional outcomes for our clients.</p>
            </div>
            <div className="why-image">
              <p>Professional Team Image</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 